import {
  LanguagesEnum,
  LanguagesNameEnum,
} from '@vedalib/editor/lib/elements/elements/Code/constants'
import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldSegmented, FieldSelect, FormField } from 'components/formKit'
import { AppMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import type { CodeFormValueType } from './codeTypes'

const THEME = genElementValueField({
  as: FieldSelect<'light' | 'dark'>,
  name: 'theme',
  label: t('input.label.theme'),
  props: {
    fluid: true,
    options: [
      { label: t('input.option.light'), value: 'light' },
      { label: t('input.option.dark'), value: 'dark' },
    ],
  },
})

const LINE_NUMBERS = genElementValueField({
  as: FieldSelect<boolean>,
  name: 'lineNumbers',
  label: t('input.label.numbering'),
  props: {
    fluid: true,
    options: [
      { label: t('input.option.show'), value: true },
      { label: t('input.option.hide'), value: false },
    ],
  },
})

const LANGUAGE = genElementValueField({
  as: FieldSelect<keyof typeof LanguagesEnum>,
  name: 'language',
  label: t('input.label.lang'),
  defaultValue: LanguagesEnum.html,
  props: {
    fluid: true,
    options: [
      { label: LanguagesNameEnum.html, value: LanguagesEnum.html },
      { label: LanguagesNameEnum.javascript, value: LanguagesEnum.javascript },
      { label: LanguagesNameEnum.css, value: LanguagesEnum.css },
      { label: LanguagesNameEnum.markdown, value: LanguagesEnum.markdown },
      { label: LanguagesNameEnum.php, value: LanguagesEnum.php },
      { label: LanguagesNameEnum.java, value: LanguagesEnum.java },
      { label: LanguagesNameEnum.python, value: LanguagesEnum.python },
      { label: LanguagesNameEnum['c/c++'], value: LanguagesEnum['c/c++'] },
      { label: LanguagesNameEnum.sql, value: LanguagesEnum.sql },
      { label: LanguagesNameEnum.node, value: LanguagesEnum.node },
      { label: LanguagesNameEnum.liquid, value: LanguagesEnum.liquid },
      { label: LanguagesNameEnum.ruby, value: LanguagesEnum.ruby },
    ],
  },
})

const SHOW_COPY_BUTTON = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showCopyButton',
  label: t('elements.code.tags.displayCopyButton'),
})

const CodeForm: CodeFormValueType = ({ name, mode }) => {
  const isPro = mode.editorMode === AppMode.pro
  return (
    <Padding bottom gap sides>
      {isPro && <FormField config={chainName(name, THEME)} />}
      <FormField config={chainName(name, LINE_NUMBERS)} />
      <FormField config={chainName(name, LANGUAGE)} />
      <FormField config={chainName(name, SHOW_COPY_BUTTON)} />
    </Padding>
  )
}

export default CodeForm
